// logger.js
const wrapConsole = (methodName) => {
  const original = console[methodName];

  console[methodName] = function (...args) {
    // Call original method so it shows in dev tools
    original.apply(console, args);

    // Construct a consistent log payload
    const payload = {
      level: methodName,
      message: args.map(arg => (typeof arg === 'object' ? JSON.stringify(arg) : String(arg))).join(' '),
      // message: 'test-error',
      pathname: window.location.pathname,
      userAgent: navigator.userAgent,
      timestamp: new Date().toISOString(),
    };

    // Optional: send to CloudWatch RUM
    if (window.AWSRum?.recordEvent) {
      window.AWSRum.recordEvent(`client_error`, payload);
    }
  };
};

// Wrap desired console methods
['error'].forEach(method => wrapConsole(method));
